import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JoinChatComponent } from './join-chat.component';
import { TinyMCEEditorModule } from '../editor/editor.module';
import { TranslateModule } from '@ngx-translate/core';
import { AutoSaveModule } from 'common/auto-save/auto-save.module';

@NgModule({
  imports: [
    CommonModule,
    TinyMCEEditorModule,
    TranslateModule.forChild(),
    AutoSaveModule
  ],
  declarations: [
    JoinChatComponent
  ],
  exports: [
    JoinChatComponent
  ]
})
export class JoinChatModule {
}
